import React from "react";
import { Modal } from "react-bootstrap";
import "./payment.css";
import invoiceIcon from "../../assets/svg/invoice-view.svg";
import personIcon from "../../assets/svg/person-ic.svg";
import closeIcon from "../../assets/svg/close-blc.svg";
import downArrowIc from "../../assets/svg/downArrowIc.svg";

const PaymentInvoiceModal = ({ show, onHide, invoice, formatCurrency }) => {
  if (!invoice) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      className="payment-invoice-modal"
    >
      <Modal.Body className="p-0">
        <div className="invoice-modal-content">
          {/* Header */}
          <div className="invoice-modal-header">
            <div className="d-flex justify-content-between align-items-start">
              <div className="invoice-header-left">
                <div className="invoice-amount">
                  {formatCurrency(invoice.totalAmount)}
                </div>

                <div className="invoice-info-item mt-3">
                  <img
                    src={invoiceIcon}
                    alt="invoice"
                    className="me-2"
                    style={{ width: "18px", height: "18px" }}
                  />
                  <span className="invoice-label">Invoice No :</span>
                  <span className="invoice-number ms-2">
                    {invoice.invoiceNo}
                  </span>
                </div>

                <div className="invoice-info-company mt-2">
                  <img
                    src={personIcon}
                    alt="customer"
                    className="me-2"
                    style={{ width: "18px", height: "18px" }}
                  />
                  <span className="invoice-customer">
                    Tata motors and assemble
                  </span>
                </div>
              </div>

              <div className="invoice-header-right">
                <button className="btn-status-pending">
                  Pending{" "}
                  <span className="ms-2">
                    <img src={downArrowIc} alt="Down arrow" />
                  </span>
                </button>
                <button className="btn-more-options ms-2">⋮</button>
              </div>
            </div>

            <button
              onClick={onHide}
              className="btn-close-modal"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Payment details */}
          <div className="invoice-section">
            <h6 className="invoice-section-title">Payment details</h6>
            <div className="payment-details-list">
              <div className="payment-detail-item">
                <div className="payment-detail-label">Payment Type</div>
                <div className="payment-detail-value">Cash</div>
              </div>
              <div className="payment-detail-item">
                <div className="payment-detail-label">Date & Time</div>
                <div className="payment-detail-value">
                  23 May 2025 at 05:40PM
                </div>
              </div>
              <div className="payment-detail-item">
                <div className="payment-detail-label">Created by</div>
                <div className="payment-detail-value">
                  23 May 2025 at 05:40PM
                  <br />
                  By Ragu Ram
                </div>
              </div>
              <div className="payment-detail-item">
                <div className="payment-detail-label">Modified by</div>
                <div className="payment-detail-value">
                  23 May 2025 at 05:40PM
                  <br />
                  By Ragu Ram
                </div>
              </div>
            </div>
          </div>

          {/* Remarks */}
          <div className="invoice-section">
            <h6 className="invoice-section-title">Remarks</h6>
            <p className="invoice-remarks">
              The word "updation" is commonly used in Indian English, especially
              in business or government contexts, but it is not standard in
              American or British English.
            </p>
          </div>

          {/* Attachment */}
          <div className="invoice-section">
            <h6 className="invoice-section-title">Attachment</h6>
            <div className="invoice-attachment">
              <div className="attachment-icon">
                <img
                  src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%2310B981'%3E%3Cpath d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/%3E%3Cpolyline points='14 2 14 8 20 8' fill='%2310B981'/%3E%3C/svg%3E"
                  alt="file"
                />
              </div>
              <div className="attachment-details">
                <div className="attachment-name">Technology_23 image.png</div>
                <div className="attachment-info">
                  <span className="attachment-size">9.45 MB</span>
                  <span className="attachment-status">
                    <span className="status-dot"></span> Uploaded
                  </span>
                </div>
              </div>
              <button className="btn-remove-attachment">
                <img src={closeIcon} alt="Remove attachment" />
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentInvoiceModal;
